module.exports = "/images/stripe_help.png?7535b630c4ebc2d5192f19d2a8a7a996";